import { render, staticRenderFns } from "./PreviewOrganiserItineraryEmail.vue?vue&type=template&id=24378ef2&scoped=true"
import script from "./PreviewOrganiserItineraryEmail.vue?vue&type=script&lang=js"
export * from "./PreviewOrganiserItineraryEmail.vue?vue&type=script&lang=js"
import style0 from "./PreviewOrganiserItineraryEmail.vue?vue&type=style&index=0&id=24378ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24378ef2",
  null
  
)

export default component.exports